/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AssistantRouteImport } from './routes/assistant'
import { Route as MeRouteImport } from './routes/me'
import { Route as PlansRouteImport } from './routes/plans'
import { Route as ShareScreenRouteImport } from './routes/share-screen'
import { Route as TravelersRouteImport } from './routes/travelers'
import { Route as HistoryIndexRouteImport } from './routes/history.index'
import { Route as HistoryConversationIdRouteImport } from './routes/history.$conversationId'
import { Route as OrdersIndexRouteImport } from './routes/orders.index'
import { Route as OrdersOrderNoRouteImport } from './routes/orders.$orderNo'
import { Route as PlannerVersionIdRouteImport } from './routes/planner.$versionId'
import { Route as BookingHotelSessionIdRouteImport } from './routes/booking.hotel.$sessionId'
import { Route as BookingPlanVersionIdRouteImport } from './routes/booking.plan.$versionId'
import { Route as MeetingGuestTokenRouteImport } from './routes/meeting.guest.$token'
import { Route as MeetingJoinIndexRouteImport } from './routes/meeting.join.index'
import { Route as MeetingJoinTokenRouteImport } from './routes/meeting.join.$token'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AssistantRoute = AssistantRouteImport.update({
  id: '/assistant',
  path: '/assistant',
  getParentRoute: () => rootRouteImport,
} as any)
const MeRoute = MeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => rootRouteImport,
} as any)
const PlansRoute = PlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => rootRouteImport,
} as any)
const ShareScreenRoute = ShareScreenRouteImport.update({
  id: '/share-screen',
  path: '/share-screen',
  getParentRoute: () => rootRouteImport,
} as any)
const TravelersRoute = TravelersRouteImport.update({
  id: '/travelers',
  path: '/travelers',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryIndexRoute = HistoryIndexRouteImport.update({
  id: '/history/',
  path: '/history/',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryConversationIdRoute = HistoryConversationIdRouteImport.update({
  id: '/history/$conversationId',
  path: '/history/$conversationId',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersIndexRoute = OrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersOrderNoRoute = OrdersOrderNoRouteImport.update({
  id: '/orders/$orderNo',
  path: '/orders/$orderNo',
  getParentRoute: () => rootRouteImport,
} as any)
const PlannerVersionIdRoute = PlannerVersionIdRouteImport.update({
  id: '/planner/$versionId',
  path: '/planner/$versionId',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingHotelSessionIdRoute = BookingHotelSessionIdRouteImport.update({
  id: '/booking/hotel/$sessionId',
  path: '/booking/hotel/$sessionId',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingPlanVersionIdRoute = BookingPlanVersionIdRouteImport.update({
  id: '/booking/plan/$versionId',
  path: '/booking/plan/$versionId',
  getParentRoute: () => rootRouteImport,
} as any)
const MeetingGuestTokenRoute = MeetingGuestTokenRouteImport.update({
  id: '/meeting/guest/$token',
  path: '/meeting/guest/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const MeetingJoinIndexRoute = MeetingJoinIndexRouteImport.update({
  id: '/meeting/join/',
  path: '/meeting/join/',
  getParentRoute: () => rootRouteImport,
} as any)
const MeetingJoinTokenRoute = MeetingJoinTokenRouteImport.update({
  id: '/meeting/join/$token',
  path: '/meeting/join/$token',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/assistant': typeof AssistantRoute
  '/me': typeof MeRoute
  '/plans': typeof PlansRoute
  '/share-screen': typeof ShareScreenRoute
  '/travelers': typeof TravelersRoute
  '/history/$conversationId': typeof HistoryConversationIdRoute
  '/orders/$orderNo': typeof OrdersOrderNoRoute
  '/planner/$versionId': typeof PlannerVersionIdRoute
  '/history/': typeof HistoryIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/booking/hotel/$sessionId': typeof BookingHotelSessionIdRoute
  '/booking/plan/$versionId': typeof BookingPlanVersionIdRoute
  '/meeting/guest/$token': typeof MeetingGuestTokenRoute
  '/meeting/join/$token': typeof MeetingJoinTokenRoute
  '/meeting/join/': typeof MeetingJoinIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/assistant': typeof AssistantRoute
  '/me': typeof MeRoute
  '/plans': typeof PlansRoute
  '/share-screen': typeof ShareScreenRoute
  '/travelers': typeof TravelersRoute
  '/history/$conversationId': typeof HistoryConversationIdRoute
  '/orders/$orderNo': typeof OrdersOrderNoRoute
  '/planner/$versionId': typeof PlannerVersionIdRoute
  '/history': typeof HistoryIndexRoute
  '/orders': typeof OrdersIndexRoute
  '/booking/hotel/$sessionId': typeof BookingHotelSessionIdRoute
  '/booking/plan/$versionId': typeof BookingPlanVersionIdRoute
  '/meeting/guest/$token': typeof MeetingGuestTokenRoute
  '/meeting/join/$token': typeof MeetingJoinTokenRoute
  '/meeting/join': typeof MeetingJoinIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/assistant': typeof AssistantRoute
  '/me': typeof MeRoute
  '/plans': typeof PlansRoute
  '/share-screen': typeof ShareScreenRoute
  '/travelers': typeof TravelersRoute
  '/history/$conversationId': typeof HistoryConversationIdRoute
  '/orders/$orderNo': typeof OrdersOrderNoRoute
  '/planner/$versionId': typeof PlannerVersionIdRoute
  '/history/': typeof HistoryIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/booking/hotel/$sessionId': typeof BookingHotelSessionIdRoute
  '/booking/plan/$versionId': typeof BookingPlanVersionIdRoute
  '/meeting/guest/$token': typeof MeetingGuestTokenRoute
  '/meeting/join/$token': typeof MeetingJoinTokenRoute
  '/meeting/join/': typeof MeetingJoinIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/assistant'
    | '/me'
    | '/plans'
    | '/share-screen'
    | '/travelers'
    | '/history/$conversationId'
    | '/orders/$orderNo'
    | '/planner/$versionId'
    | '/history/'
    | '/orders/'
    | '/booking/hotel/$sessionId'
    | '/booking/plan/$versionId'
    | '/meeting/guest/$token'
    | '/meeting/join/$token'
    | '/meeting/join/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/assistant'
    | '/me'
    | '/plans'
    | '/share-screen'
    | '/travelers'
    | '/history/$conversationId'
    | '/orders/$orderNo'
    | '/planner/$versionId'
    | '/history'
    | '/orders'
    | '/booking/hotel/$sessionId'
    | '/booking/plan/$versionId'
    | '/meeting/guest/$token'
    | '/meeting/join/$token'
    | '/meeting/join'
  id:
    | '__root__'
    | '/'
    | '/assistant'
    | '/me'
    | '/plans'
    | '/share-screen'
    | '/travelers'
    | '/history/$conversationId'
    | '/orders/$orderNo'
    | '/planner/$versionId'
    | '/history/'
    | '/orders/'
    | '/booking/hotel/$sessionId'
    | '/booking/plan/$versionId'
    | '/meeting/guest/$token'
    | '/meeting/join/$token'
    | '/meeting/join/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AssistantRoute: typeof AssistantRoute
  MeRoute: typeof MeRoute
  PlansRoute: typeof PlansRoute
  ShareScreenRoute: typeof ShareScreenRoute
  TravelersRoute: typeof TravelersRoute
  HistoryConversationIdRoute: typeof HistoryConversationIdRoute
  OrdersOrderNoRoute: typeof OrdersOrderNoRoute
  PlannerVersionIdRoute: typeof PlannerVersionIdRoute
  HistoryIndexRoute: typeof HistoryIndexRoute
  OrdersIndexRoute: typeof OrdersIndexRoute
  BookingHotelSessionIdRoute: typeof BookingHotelSessionIdRoute
  BookingPlanVersionIdRoute: typeof BookingPlanVersionIdRoute
  MeetingGuestTokenRoute: typeof MeetingGuestTokenRoute
  MeetingJoinTokenRoute: typeof MeetingJoinTokenRoute
  MeetingJoinIndexRoute: typeof MeetingJoinIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assistant': {
      id: '/assistant'
      path: '/assistant'
      fullPath: '/assistant'
      preLoaderRoute: typeof AssistantRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/me': {
      id: '/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof MeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plans': {
      id: '/plans'
      path: '/plans'
      fullPath: '/plans'
      preLoaderRoute: typeof PlansRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/share-screen': {
      id: '/share-screen'
      path: '/share-screen'
      fullPath: '/share-screen'
      preLoaderRoute: typeof ShareScreenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/travelers': {
      id: '/travelers'
      path: '/travelers'
      fullPath: '/travelers'
      preLoaderRoute: typeof TravelersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history/': {
      id: '/history/'
      path: '/history'
      fullPath: '/history/'
      preLoaderRoute: typeof HistoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history/$conversationId': {
      id: '/history/$conversationId'
      path: '/history/$conversationId'
      fullPath: '/history/$conversationId'
      preLoaderRoute: typeof HistoryConversationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/': {
      id: '/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof OrdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/$orderNo': {
      id: '/orders/$orderNo'
      path: '/orders/$orderNo'
      fullPath: '/orders/$orderNo'
      preLoaderRoute: typeof OrdersOrderNoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/planner/$versionId': {
      id: '/planner/$versionId'
      path: '/planner/$versionId'
      fullPath: '/planner/$versionId'
      preLoaderRoute: typeof PlannerVersionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/booking/hotel/$sessionId': {
      id: '/booking/hotel/$sessionId'
      path: '/booking/hotel/$sessionId'
      fullPath: '/booking/hotel/$sessionId'
      preLoaderRoute: typeof BookingHotelSessionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/booking/plan/$versionId': {
      id: '/booking/plan/$versionId'
      path: '/booking/plan/$versionId'
      fullPath: '/booking/plan/$versionId'
      preLoaderRoute: typeof BookingPlanVersionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/meeting/guest/$token': {
      id: '/meeting/guest/$token'
      path: '/meeting/guest/$token'
      fullPath: '/meeting/guest/$token'
      preLoaderRoute: typeof MeetingGuestTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/meeting/join/': {
      id: '/meeting/join/'
      path: '/meeting/join'
      fullPath: '/meeting/join/'
      preLoaderRoute: typeof MeetingJoinIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/meeting/join/$token': {
      id: '/meeting/join/$token'
      path: '/meeting/join/$token'
      fullPath: '/meeting/join/$token'
      preLoaderRoute: typeof MeetingJoinTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AssistantRoute: AssistantRoute,
  MeRoute: MeRoute,
  PlansRoute: PlansRoute,
  ShareScreenRoute: ShareScreenRoute,
  TravelersRoute: TravelersRoute,
  HistoryConversationIdRoute: HistoryConversationIdRoute,
  OrdersOrderNoRoute: OrdersOrderNoRoute,
  PlannerVersionIdRoute: PlannerVersionIdRoute,
  HistoryIndexRoute: HistoryIndexRoute,
  OrdersIndexRoute: OrdersIndexRoute,
  BookingHotelSessionIdRoute: BookingHotelSessionIdRoute,
  BookingPlanVersionIdRoute: BookingPlanVersionIdRoute,
  MeetingGuestTokenRoute: MeetingGuestTokenRoute,
  MeetingJoinTokenRoute: MeetingJoinTokenRoute,
  MeetingJoinIndexRoute: MeetingJoinIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
